// Attribution: https://codepen.io/vdel26/pen/rKpzg
import cn from "classnames";

import Styles from "./ActivityIndicator.module.scss";

export type ActivityIndicatorType = "spinner" | "mesh";
type SpinnerColor = "light" | "dark" | "blue";
type Size = "xl" | "large" | "medium" | "small";

interface SpinnerProps {
  color?: SpinnerColor;
  size?: Size;
  show?: boolean;
  className?: string;
}

const Spinner = ({
  color = "dark",
  size = "small",
  show = true,
  className,
}: SpinnerProps) => {
  if (!show) {
    return null;
  }

  const spinner = cn(Styles.spinner, Styles[color], Styles[size], className);

  return (
    <div className={spinner} data-testid="activity-indicator-spinner">
      <div className={Styles.bar1} />
      <div className={Styles.bar2} />
      <div className={Styles.bar3} />
      <div className={Styles.bar4} />
      <div className={Styles.bar5} />
      <div className={Styles.bar6} />
      <div className={Styles.bar7} />
      <div className={Styles.bar8} />
      <div className={Styles.bar9} />
      <div className={Styles.bar10} />
      <div className={Styles.bar11} />
      <div className={Styles.bar12} />
    </div>
  );
};

const ActivityIndicator = {
  Spinner,
};

export { ActivityIndicator };
